"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.list.title': 'Tutorials',
    'tutorial.list.empty.title': 'Keine Tutorials gefunden',
    'tutorial.list.empty.message': 'Erstelle dein erstes Tutorial, um mit interaktiven Lern-Erlebnissen zu beginnen.',
    'tutorial.expired': 'Abgelaufen',
    'tutorial.draft': 'Entwurf',
};
